import { useCallback, useMemo } from 'react';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import useReadOnly from 'framework-asset-preview-lib/internal/shared/hooks/useReadOnly';
import { useInlineEdit } from 'framework-asset-preview-lib/internal/shared/providers/InlineEditProvider';
import StringPropertyValue from './StringPropertyValue';
import StyledValue from './StyledValue';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyValue({
  crmObject,
  property,
  propertyName,
  valueComponentProps = {
    dateTimeFormat: 'll'
  },
  use
}) {
  const readOnly = useReadOnly();
  const {
    getValue,
    onChange,
    onResetValue,
    onValidationChange
  } = useInlineEdit();
  const value = useMemo(() => {
    const propertyValue = getPropertyValue(crmObject, propertyName, '');
    if (!propertyValue) {
      return '';
    }
    return `${propertyValue}`;
  }, [crmObject, propertyName]);
  const getAdditionalPropertyValue = useCallback(name => {
    const savedValue = getPropertyValue(crmObject, name);
    return getValue ? getValue(name, savedValue) : savedValue;
  }, [getValue, crmObject]);
  const handleChange = useCallback(changes => {
    if (changes[propertyName] === value) {
      onChange(changes);
      onResetValue(propertyName);
    } else {
      onChange(changes);
    }
  }, [onChange, onResetValue, propertyName, value]);
  if (property && !readOnly) {
    return /*#__PURE__*/_jsx(StyledValue, {
      "data-test-property-name": propertyName,
      "data-test-property-type": property.type,
      children: /*#__PURE__*/_jsx(PropertyInputV2, {
        formControlProps: {
          verticalSeparation: 'flush'
        },
        inputProps: {
          'data-test-id': 'property-input',
          'data-test-property-name': propertyName
        },
        getAdditionalPropertyValue: getAdditionalPropertyValue,
        objectId: `${crmObject.objectId}`,
        objectTypeId: crmObject.objectTypeId,
        onChange: handleChange,
        onValidationChange: onValidationChange,
        property: property,
        use: use || 'floating',
        value: getValue(property.name, value),
        enableConditionalPropertiesPanel: true,
        enableConditionalPropertyOptions: true
      })
    });
  }
  if (property) {
    return /*#__PURE__*/_jsx(StyledValue, {
      "data-test-property-name": propertyName,
      "data-test-property-type": property.type,
      children: /*#__PURE__*/_jsx(FormattedPropertyV2, Object.assign({
        "data-test-id": "formatted-property-v2",
        getAdditionalPropertyValue: getAdditionalPropertyValue,
        objectId: `${crmObject.objectId}`,
        objectTypeId: crmObject.objectTypeId,
        property: property,
        value: value
      }, valueComponentProps))
    });
  }
  return /*#__PURE__*/_jsx(StringPropertyValue, {
    propertyName: propertyName,
    value: value
  });
}